import { render } from "./DivisionLeadersThurB.vue?vue&type=template&id=7dbfd9f6&scoped=true"
import script from "./DivisionLeadersThurB.vue?vue&type=script&scoped=true&lang=js"
export * from "./DivisionLeadersThurB.vue?vue&type=script&scoped=true&lang=js"

import "./DivisionLeadersThurB.vue?vue&type=style&index=0&id=7dbfd9f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dbfd9f6"]])

export default __exports__